export let POSTHOG_SHOW_SURVEY = 'POSTHOG_SHOW_SURVEY';

export let posthogShowSurvey = (surveyId) => ({type: POSTHOG_SHOW_SURVEY, payload: {surveyId}})
